import castSlice from "./component-library233.mjs";
import hasUnicode from "./component-library234.mjs";
import stringToArray from "./component-library235.mjs";
import toString from "./component-library203.mjs";
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
    var chr = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
    return chr[methodName]() + trailing;
  };
}
export {
  createCaseFirst as default
};
